import React, { useEffect, useRef, useState } from 'react';
import { Link, useNavigate, useSearchParams } from 'react-router-dom';
import { authService } from '../services/auth';

export default function SsoCallback() {
  const [searchParams] = useSearchParams();
  const navigate = useNavigate();
  const startedRef = useRef(false);
  const code = searchParams.get('code');
  const [error, setError] = useState(() => (
    code ? '' : 'The NovaMatch sign-in link is incomplete.'
  ));

  useEffect(() => {
    if (startedRef.current) return;
    startedRef.current = true;
    if (!code) return;

    authService.exchangeSsoCode(code)
      .then(() => {
        navigate('/app', { replace: true });
      })
      .catch((requestError) => {
        setError(requestError.message || 'Could not complete NovaMatch sign-in.');
      });
  }, [code, navigate]);

  return (
    <div style={{
      minHeight: '100vh',
      display: 'flex',
      alignItems: 'center',
      justifyContent: 'center',
      padding: '24px',
      background: 'linear-gradient(145deg, #f8fafc 0%, #eef2ff 100%)'
    }}>
      <div style={{
        width: '100%',
        maxWidth: 420,
        borderRadius: 18,
        background: '#fff',
        boxShadow: '0 18px 50px rgba(15, 23, 42, 0.12)',
        padding: '32px 28px',
        textAlign: 'center'
      }}>
        {error ? (
          <>
            <h1 style={{ margin: 0, fontSize: '1.25rem', color: '#0f172a' }}>
              Sign-in could not be completed
            </h1>
            <p style={{ margin: '12px 0 0', color: '#64748b', fontSize: '0.92rem' }}>{error}</p>
            <Link
              to="/login"
              replace
              style={{
                display: 'inline-flex',
                marginTop: 22,
                borderRadius: 10,
                background: '#4f46e5',
                color: '#fff',
                textDecoration: 'none',
                fontSize: '0.9rem',
                fontWeight: 600,
                padding: '10px 16px'
              }}
            >
              Go to NovaMatch login
            </Link>
          </>
        ) : (
          <>
            <div style={{
              width: 40,
              height: 40,
              margin: '0 auto',
              borderRadius: '50%',
              border: '3px solid #c7d2fe',
              borderBottomColor: '#4f46e5',
              animation: 'novamatch-sso-spin 0.8s linear infinite'
            }} />
            <h1 style={{ margin: '18px 0 0', fontSize: '1.25rem', color: '#0f172a' }}>
              Opening NovaMatch
            </h1>
            <p style={{ margin: '10px 0 0', color: '#64748b', fontSize: '0.92rem' }}>
              Completing your secure sign-in…
            </p>
            <style>{`@keyframes novamatch-sso-spin { to { transform: rotate(360deg); } }`}</style>
          </>
        )}
      </div>
    </div>
  );
}
